"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreServiceHelper = void 0;
var UserCache_1 = require("./../../UserCache");
var Utils_1 = require("../../../utils/Utils");
var Settings_1 = require("../../Settings");
var UserCache_2 = require("../../UserCache");
var DataStatsManager_1 = require("../../DataStatsManager");
var DataSyncProviderImpl_1 = require("./DataSyncProviderImpl");
var CoreServiceHelper = (function () {
    function CoreServiceHelper(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.realTimeObj = {
            tasks: ['kernelName'],
            files: ['uid'],
            stop: ['kernelName'],
            code: ['unit', 'courseId', 'lessonId', 'exerciseId', 'uid'],
            studentStatus: ['unit', 'courseId', 'lessonId', 'exerciseId', 'uid'],
            notifications: ['unit', 'uid'],
            questionComments: ['unit', 'courseId', 'uid', 'questionId', 'commentId'],
            kernels: ['name', 'kernelType'],
            courses: ['unit', 'id'],
            videoConference: ['unit', 'courseId', 'studentIds']
        };
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " CoreServiceHelper#")], args, false));
        };
        this.testSpeed = function () {
            var lastTime = Date.now();
            if (!_this.speedTestDetectTime || lastTime - _this.speedTestDetectTime > 90000) {
                _this.log('testSpeed# speed test start!');
                _this.speedTestDetectTime = lastTime;
            }
            else {
                _this.log('testSpeed# stop testing speed');
                return Promise.resolve();
            }
            return new Promise(function (resolve, reject) {
                fetch('https://api2.codingbar.net/file/public?name=microbit_test.hex')
                    .then(function (a) { return a.text(); })
                    .then(function () { return resolve(Date.now() - lastTime); })
                    .catch(function (err) { return resolve({}); });
            });
        };
        this.saveSpeedTestResult = function (url, body, speedTestTime) {
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert, {
                collection: 'SpeedTestResult',
                data: {
                    url: url,
                    body: JSON.parse(body),
                    speedTestTime: speedTestTime,
                },
            }, false);
        };
        this.post = function (url, contentType, body, isCheckResTime, header) {
            var headers = header
                ? header
                : {
                    'content-type': contentType,
                    authorization: _this.token,
                };
            if (!headers['authorization']) {
                delete headers['authorization'];
            }
            var functionName = _this.callerName().functionName;
            var stack = _this.callerName().stack;
            var lastTime = Date.now();
            var host = window.location.host;
            var pathname = window.location.pathname;
            return fetch(url, {
                body: body,
                cache: 'no-cache',
                headers: headers,
                method: 'POST',
                mode: 'cors',
                redirect: 'follow',
                referrer: 'no-referrer',
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (resObj) {
                var resTime = Date.now() - lastTime;
                if (isCheckResTime && resTime > 5000) {
                    _this.log('post# resTime > 5s');
                }
                if (resObj['status'] && resObj['status'] !== 'success') {
                    var content = "url:".concat(url, " host:").concat(host, " pathname:").concat(pathname, " filter:").concat(JSON.stringify(body['filter']), " res:").concat(JSON.stringify(resObj));
                    localStorage.setItem("error_".concat(Date.now()), content);
                }
                return Promise.resolve(resObj);
            })
                .catch(function (err) {
                var content = "url:".concat(url, " host:").concat(host, " pathname:").concat(pathname, " filter:").concat(JSON.stringify(body['filter']), " res:").concat(JSON.stringify(err));
                localStorage.setItem("error_catch_".concat(Date.now()), content);
                return Promise.reject(err);
            });
        };
        this.postJson = function (url, body, isCheckResTime, header) {
            if (isCheckResTime !== false) {
                isCheckResTime = true;
            }
            body.email = body.email ? body.email : _this.email;
            var host = window.location.host;
            var pathname = window.location.pathname;
            var beginTime = Date.now();
            var timeoutInstance = undefined;
            if (_this.speedListener) {
                var slowInfo_1 = {
                    requestEndPoint: url,
                    requestPayload: body,
                    host: host,
                    pathname: pathname,
                };
                timeoutInstance = setTimeout(function () {
                    timeoutInstance = undefined;
                    _this.speedListener.onSlowQuery(slowInfo_1);
                }, _this.speedListener.threshold ? _this.speedListener.threshold : 10000);
                _this.log('timeoutInstance', timeoutInstance);
            }
            return _this.post(url, 'application/json', JSON.stringify(body), isCheckResTime, header).then(function (res) {
                var queryTime = Date.now() - beginTime;
                var usageData = {
                    requestEndPoint: url,
                    reqSize: JSON.stringify(body ? body : {}).length,
                    resSize: JSON.stringify(res ? res : {}).length,
                    host: host,
                    pathname: pathname,
                    queryTime: queryTime,
                };
                if (timeoutInstance) {
                    try {
                        clearTimeout(timeoutInstance);
                    }
                    catch (err) {
                        _this.log('err', err);
                    }
                    timeoutInstance = undefined;
                }
                (0, DataStatsManager_1.trackAPIUsage)(_this.speedListener && _this.speedListener.usageUploadInterval
                    ? _this.speedListener.usageUploadInterval
                    : 30 * 1000, usageData, _this.cfg);
                return res;
            });
        };
        this.postRawJson = function (url, body, isCheckResTime, header) {
            if (isCheckResTime !== false) {
                isCheckResTime = true;
            }
            return _this.post(url, 'application/json', JSON.stringify(body), isCheckResTime, header).then(function (res) {
                return res;
            });
        };
        this.postText = function (url, body, isCheckResTime) {
            if (isCheckResTime !== false) {
                isCheckResTime = true;
            }
            return _this.post(url, 'text/plain', JSON.stringify(body), isCheckResTime).then(function (res) {
                (0, DataStatsManager_1.createDataStats)({ out: body, in: res }, _this.cfg);
                return res;
            });
        };
        this.sendEmail = function (receivers, subject, content) {
            var body = {
                receivers: receivers,
                subject: subject,
                content: content,
                api_key: 'YWlyYWJiaWlhbQ==',
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_email_send, body, false);
        };
        this.sendEmailEx = function (receivers, subject, content, ccList) {
            var body = {
                receivers: receivers,
                subject: subject,
                content: content,
                ccList: ccList,
                api_key: 'YWlyYWJiaWlhbQ==',
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_email_send, body, false);
        };
        this.sendEvent = function (event) {
            var body = {
                event: event,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_event_create, body);
        };
        this.submitCode = function (task) {
            if (!task) {
                return Promise.reject('task cannot be empty!');
            }
            var body = { task: task };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_upload_tasks, body);
        };
        this.submitCodeInLocal = function (task) {
            if (!task) {
                return Promise.reject('task cannot be empty!');
            }
            var body = { task: task };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_upload_tasks_in_local, body);
        };
        this.isCorrectPhoneNumsFormat = function (phoneNums) {
            if (!Array.isArray(phoneNums) || phoneNums.length === 0) {
                return false;
            }
            var isValid = true;
            var regex = /^[0-9]+$/;
            phoneNums.forEach(function (phoneNum) {
                phoneNum = phoneNum.trim();
                if (!phoneNum.match(regex)) {
                    isValid = false;
                }
            });
            return isValid;
        };
        this.sendSms = function (phoneNums, content) {
            if (!_this.isCorrectPhoneNumsFormat(phoneNums) || !content) {
                return Promise.reject('format wrong!');
            }
            var DEST = '';
            phoneNums.forEach(function (phoneNum, index) {
                if (index === phoneNums.length - 1) {
                    DEST += phoneNum;
                    return;
                }
                DEST += "".concat(phoneNum.trim(), ",");
            });
            var body = {
                content: content,
                DEST: DEST,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_send_Sms, body);
        };
        this.sendSmsByFormId = function (formId, content) {
            if (!formId || !content) {
                return Promise.reject('format wrong!');
            }
            var body = {
                formId: formId,
                content: content,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_send_Sms_by_formId, body);
        };
        this.getCourseSingleContent = function (unit, courseId, lessonId, exerciseId) {
            var body = {
                filter: {
                    unit: unit,
                    id: courseId,
                },
                lessonId: lessonId,
                exerciseId: exerciseId,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_get_course_single_content, body);
        };
        this.readTip = function (unit, courseId, lessonId, exerciseId, uid, lessonIndex, exerciseIndex, tipIndex, tip) {
            var body = {
                unit: unit,
                courseId: courseId,
                lessonId: lessonId,
                exerciseId: exerciseId,
                uid: uid,
                lessonIndex: lessonIndex,
                exerciseIndex: exerciseIndex,
                tipIndex: tipIndex,
                tip: tip,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_read_tip, body);
        };
        this.readAnswer = function (unit, courseId, lessonId, exerciseId, uid, lessonIndex, exerciseIndex, ansIndex, answer) {
            var body = {
                unit: unit,
                courseId: courseId,
                lessonId: lessonId,
                exerciseId: exerciseId,
                uid: uid,
                lessonIndex: lessonIndex,
                exerciseIndex: exerciseIndex,
                ansIndex: ansIndex,
                answer: answer,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_read_answer, body);
        };
        this.createData = function (collection, value) {
            var body = { collection: collection, data: value };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert, body).then(function (res) {
                _this.sendRealTimeNotification(collection, {}, value);
                return res;
            });
        };
        this.insertRecordData = function (collection, value) {
            var body = { collection: collection, data: value };
            return _this.postRawJson('https://api2.codingbar.ai/record/data/insert', body).then(function (res) {
                return res;
            });
        };
        this.updateData = function (collection, filter, value) {
            var body = { collection: collection, filter: filter, data: value };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_update_one, body).then(function (res) {
                _this.sendRealTimeNotification(collection, filter, value);
                return res;
            });
        };
        this.patchData = function (collection, filter, value) {
            var body = { collection: collection, filter: filter, data: value };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_patch_one, body).then(function (res) {
                _this.sendRealTimeNotification(collection, filter, value);
                return res;
            });
        };
        this.addSetData = function (collection, filter, value) {
            var body = { collection: collection, filter: filter, data: value };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_add_set_one, body).then(function (res) {
                return res;
            });
        };
        this.sendVerifiedEmail = function (email, psw) {
            var body = { email: email, psw: psw };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_send_verified_email, body);
        };
        this.resendVerifiedEmail = function (email) {
            var body = { email: email };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_resend_verified_email, body);
        };
        this.stopTask = function (uid) {
            var body = { uid: uid };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_stop_tasks, body);
        };
        this.checkCoupon = function (couponType, classId, code, generalFormId) {
            var body = {
                couponType: couponType,
                formId: classId,
                code: code,
                version: '2.1',
                generalFormId: generalFormId,
                classId: classId,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_check_discount_code, body);
        };
        this.patchRegistrationForm = function (form) {
            var body = { form: form };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_patch_registration_form, body);
        };
        this.insertSignUpUser = function (signUpUser) {
            var body = { signUpUsers: signUpUser };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert_sign_up_users, body);
        };
        this.updateStudClickReportHistory = function (courseId, lessonId, studentId) {
            if (!courseId || !lessonId || !studentId) {
                return Promise.reject('params blank error!');
            }
            var body = { courseId: courseId, lessonId: lessonId, studentId: studentId };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_update_stud_click_report_history, body).then(function (res) {
                return res;
            });
        };
        this.setData = function (collection, filter, path, value) {
            var body = { collection: collection, filter: filter, data: {} };
            var data = {};
            data[path] = value;
            body.data = data;
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_update_one, body);
        };
        this.removeData = function (collection, filter) {
            var body = { collection: collection, filter: filter };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_remove_one, body).then(function (res) {
                _this.sendRealTimeNotification(collection, filter, {});
                return res;
            });
        };
        this.removeRealTimeNotification = function () {
            var body = {};
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_remove_real_time_notification, body);
        };
        this.fetchToken = function (email) {
            var body = { email: email };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_fetch_token, body).then(function (res) {
                _this.token = res.token;
                _this.email = email;
                return res;
            });
        };
        this.login = function (email, password) {
            password = btoa(password);
            var body = { email: email, password: password };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_login, body).then(function (res) {
                _this.token = res.token;
                _this.email = email;
                return res;
            });
        };
        this.logout = function () {
            var body = { email: _this.email };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_logout, body).then(function (res) {
                _this.token = '';
                _this.email = '';
                return res;
            });
        };
        this.countData = function (collection, filter) {
            _this.mergeUnitsFilter(collection, filter);
            var body = {
                collection: collection,
                filter: filter,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_count, body);
        };
        this.countDataWithoutUnitMerge = function (collection, filter) {
            var body = {
                collection: collection,
                filter: filter,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_count, body);
        };
        this.getLiveCourses = function (beginTime, endTime) {
            var body = {
                collection: 'courses',
                filter: {
                    $or: [
                        {
                            lessons: {
                                $elemMatch: {
                                    beginTime: {
                                        $gte: beginTime,
                                    },
                                    endTime: {
                                        $lte: endTime,
                                    },
                                },
                            },
                        },
                        {
                            tests: {
                                $elemMatch: {
                                    beginTime: {
                                        $gte: beginTime,
                                    },
                                    endTime: {
                                        $lte: endTime,
                                    },
                                },
                            },
                        },
                    ],
                },
                sort: {},
                projection: {
                    'lessons.exercises.content': false,
                    'lessons.offlineExercises.content': false,
                    'tests.exercises.content': false,
                    'lessons.exercises.tips': false,
                    'lessons.offlineExercises.tips': false,
                    'tests.exercises.tips': false,
                    'lessons.exercises.answers': false,
                    'lessons.offlineExercises.answers': false,
                    'tests.exercises.answers': false,
                    'lessons.exercises.vds': false,
                    'lessons.offlineExercises.vds': false,
                    'tests.exercises.vds': false,
                },
                distinctKey: '',
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select, body).then(function (result) {
                var liveCourses = result.result ? result.result : [];
                var returnObj = {
                    courses: [],
                    unitList: [],
                    studentIdList: [],
                    teacherIdList: [],
                };
                liveCourses.forEach(function (liveCourse) {
                    var temp = {
                        id: liveCourse.id,
                        lessons: [],
                        tests: [],
                    };
                    liveCourse.lessons = liveCourse.lessons ? liveCourse.lessons : [];
                    liveCourse.tests = liveCourse.tests ? liveCourse.tests : [];
                    liveCourse.students = liveCourse.students ? liveCourse.students : [];
                    liveCourse.teachers = liveCourse.teachers ? liveCourse.teachers : [];
                    liveCourse.lessons.forEach(function (lesson) {
                        if (lesson.beginTime >= beginTime && lesson.endTime <= endTime) {
                            temp.lessons.push(lesson);
                        }
                    });
                    liveCourse.tests.forEach(function (test) {
                        if (test.beginTime >= beginTime && test.endTime <= endTime) {
                            temp.tests.push(test);
                        }
                    });
                    returnObj.courses.push(temp);
                    liveCourse.students.forEach(function (student) {
                        if (!returnObj.studentIdList.find(function (studentIdInTemp) { return studentIdInTemp === student.uid; })) {
                            returnObj.studentIdList.push(student.uid);
                        }
                    });
                    liveCourse.teachers.forEach(function (teacher) {
                        if (!returnObj.teacherIdList.find(function (teacherIdInTemp) { return teacherIdInTemp === teacher.uid; })) {
                            returnObj.teacherIdList.push(teacher.uid);
                        }
                    });
                    if (!returnObj.unitList.find(function (unitInTemp) { return unitInTemp === liveCourse.unit; })) {
                        returnObj.unitList.push(liveCourse.unit);
                    }
                });
                return returnObj;
            });
        };
        this.queryData = function (collection, filter, sort, projection, distinctKey) {
            _this.mergeUnitsFilter(collection, filter);
            var body = {
                collection: collection,
                filter: filter,
                sort: sort,
                projection: projection,
                distinctKey: distinctKey,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select, body);
        };
        this.queryDataWithoutUnitMerge = function (collection, filter, sort, projection, distinctKey) {
            var body = {
                collection: collection,
                filter: filter,
                sort: sort,
                projection: projection,
                distinctKey: distinctKey,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select, body);
        };
        this.queryOne = function (collection, filter, projection) {
            _this.mergeUnitsFilter(collection, filter);
            var body = {
                collection: collection,
                filter: filter,
                projection: projection,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select_one, body);
        };
        this.queryOneWithoutUnitMerge = function (collection, filter, projection) {
            var body = {
                collection: collection,
                filter: filter,
                projection: projection,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select_one, body);
        };
        this.query = function (collection, filter, sort, projection, distinctKey, skip, limit) {
            _this.mergeUnitsFilter(collection, filter);
            var body = {
                collection: collection,
                filter: filter,
                sort: sort,
                projection: projection,
                distinctKey: distinctKey,
                skip: skip,
                limit: limit,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select, body);
        };
        this.queryPagination = function (collection, filter, sort, skip, limit, searchKeys, searchString, projection) {
            if (projection === void 0) { projection = {}; }
            _this.mergeUnitsFilter(collection, filter);
            var body = {
                collection: collection,
                filter: filter,
                sort: sort,
                skip: skip,
                limit: limit,
                searchKeys: searchKeys,
                searchString: searchString,
                projection: projection,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select_pagination, body);
        };
        this.queryPaginationWithoutUnitMerge = function (collection, filter, sort, skip, limit, searchKeys, searchString, projection) {
            if (projection === void 0) { projection = {}; }
            var body = {
                collection: collection,
                filter: filter,
                sort: sort,
                skip: skip,
                limit: limit,
                searchKeys: searchKeys,
                searchString: searchString,
                projection: projection,
            };
            return _this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_select_pagination, body);
        };
        this.log('CoreServiceHelper#', cfg);
        if (!cfg.connectionInfo) {
            cfg.connectionInfo = {};
        }
    }
    CoreServiceHelper.getHelper = function (cfg) {
        if (CoreServiceHelper.singleton) {
            return CoreServiceHelper.singleton;
        }
        CoreServiceHelper.singleton = new CoreServiceHelper(cfg);
        CoreServiceHelper.singleton2 = new CoreServiceHelper(cfg);
        return CoreServiceHelper.singleton;
    };
    CoreServiceHelper.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('CoreServiceHelper#init');
        this.dataSyncProvider = new DataSyncProviderImpl_1.DataSyncProviderImpl(cfg);
        this.log('CoreServiceHelper#init#dataSyncProvider', this.dataSyncProvider);
        return this.dataSyncProvider.init(env);
    };
    CoreServiceHelper.prototype.sendEventNotify = function (unit, event, message) {
        var collection = 'events';
        var filter = {
            unit: unit,
            event: event,
        };
        return this.updateData(collection, filter, message);
    };
    CoreServiceHelper.prototype.subscribeEventNotify = function (unit, event, listener) {
        var _this = this;
        if (!unit || unit.trim() === '') {
            this.log('startListenEvent#', 'unit cannot be empty!');
            return;
        }
        if (!listener) {
            this.log('startListenEvent#', 'listener cannot be empty!');
            return;
        }
        var collection = 'events';
        var path = "/units/".concat(unit, "/event/").concat(event);
        this.log('startListenEvent#', path);
        this.log('startListenEvent#', this.dataSyncProvider);
        this.dataSyncProvider
            .unsubscribe(this.dataSyncNode)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    listener.onChanged(data);
                },
            };
            var projection = {};
            _this.dataSyncProvider
                .subscribe(path, path, dataSyncListener, collection, {
                unit: unit,
                event: event,
            }, projection)
                .then(function (dataSyncNode) {
                _this.dataSyncNode = dataSyncNode;
                _this.log('startListenEvent#', "subscribe ".concat(path, " successfully!"));
            })
                .catch(function (err) {
                _this.log(err);
                _this.log('startListenEvent#', "subscribe ".concat(path, " error!"));
            });
        })
            .catch(function (err) { return _this.log(err); });
    };
    CoreServiceHelper.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    CoreServiceHelper.prototype.callerName = function () {
        try {
            throw new Error();
        }
        catch (e) {
            try {
                return {
                    functionName: e.stack.split('at ')[6],
                    stack: e.stack,
                };
            }
            catch (e) {
                return {};
            }
        }
    };
    CoreServiceHelper.prototype.sendLongLatencyReqEmail = function (resTime, speedTestTime, functionName, reqBody, stack) {
        this.sendEmail(['edison.liang@airabbi.com'], '[Long Latency] CodingBar API Over 5s', "<div>callee function: ".concat(functionName, " </div> <div>speedTestTime: ").concat(speedTestTime, " </div> <div>response time: ").concat(resTime, " ms </div> <div> req body: ").concat(reqBody, " </div> <div> stack: ").concat(stack, " </div>"));
        this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert, {
            collection: 'Over5s',
            data: {
                functionName: functionName,
                resTime: resTime,
                speedTestTime: speedTestTime,
                reqBody: reqBody,
                stack: stack,
            },
        }, false);
    };
    CoreServiceHelper.prototype.sendRealTimeNotification = function (collection, filter, value) {
        var realTimeObjKey = Object.keys(this.realTimeObj).find(function (key) { return key === collection; });
        if (realTimeObjKey) {
            var body_1 = {
                collection: collection,
                filter: {},
            };
            this.realTimeObj[realTimeObjKey].forEach(function (eachFilter) {
                if (filter[eachFilter])
                    body_1['filter'][eachFilter] = filter[eachFilter];
                if (value[eachFilter])
                    body_1['filter'][eachFilter] = value[eachFilter];
            });
            var header = {
                'Content-Type': 'application/json',
                'X-Parse-Application-Id': 'myAppId',
                'X-Parse-Master-Key': 'myMasterKey',
            };
            return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert_real_time_notification, body_1, false, header);
        }
        return Promise.resolve(undefined);
    };
    CoreServiceHelper.prototype.sendCodeRealTimeNotification = function (unit, courseId, lessonId, exerciseId, uid, isOpenSync) {
        var body = {
            collection: 'isUpdateCode',
            filter: {
                unit: unit,
                courseId: courseId,
                uid: uid,
            },
            isOpenSync: isOpenSync,
            teacherUid: UserCache_1.currentUser.uid,
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId,
        };
        var header = {
            'Content-Type': 'application/json',
            'X-Parse-Application-Id': 'myAppId',
            'X-Parse-Master-Key': 'myMasterKey',
        };
        return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert_real_time_notification, body, false, header);
    };
    CoreServiceHelper.prototype.createEventNotification = function (unit, event) {
        var body = {
            collection: 'events-notify',
            filter: {
                unit: unit,
                event: event,
            },
        };
        var header = {
            'Content-Type': 'application/json',
            'X-Parse-Application-Id': 'myAppId',
            'X-Parse-Master-Key': 'myMasterKey',
        };
        return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_insert_real_time_notification, body, false, header);
    };
    CoreServiceHelper.prototype.enableMergeUnitsFilter = function () {
        localStorage.removeItem('disableMergeUnitsFilter');
    };
    CoreServiceHelper.prototype.disableMergeUnitsFilter = function () {
        localStorage.setItem('disableMergeUnitsFilter', 'true');
    };
    CoreServiceHelper.prototype.mergeUnitsFilter = function (collection, filter) {
        if (localStorage.getItem('disableMergeUnitsFilter') === 'true') {
            this.log('mergeUnitsFilter', 'disabled!');
            return;
        }
        var user = (0, UserCache_2.loadUser)();
        if (!(collection === 'courses' ||
            (collection === 'Users' && filter['role'] === 'student') ||
            collection === 'studentStatus' ||
            (user && user.uid === 'developer-airabbi-com'))) {
            return;
        }
        if (filter && filter.unit) {
            var nonUniqueUnits = __spreadArray([filter.unit, user.unit], (filter.units || user.units), true);
            if (filter.isGlobalTest) {
                nonUniqueUnits = __spreadArray(__spreadArray([], nonUniqueUnits, true), ['airabbi'], false);
                delete filter['isGlobalTest'];
            }
            var uniqueUnits = __spreadArray([], Array.from(new Set(nonUniqueUnits)), true);
            filter['$or'] = [
                { unit: { $in: uniqueUnits } },
                { units: { $in: filter.units || user.units } },
            ];
            delete filter['unit'];
            delete filter['units'];
        }
        this.log('mergeUnitsFilter filter: ', filter);
    };
    CoreServiceHelper.prototype.createEvent = function (title, content) {
        var _this = this;
        var user = (0, UserCache_2.loadUser)();
        if (!user) {
            this.log('createEvent# user not exist!');
        }
        var event = {
            user: user
                ? {
                    uid: user.uid,
                    email: user.email,
                    name: user.displayName,
                    role: user.role ? user.role : '',
                    unit: user.unit ? user.unit : '',
                }
                : '',
            env: this.env,
            title: title,
            content: content,
        };
        this.sendEvent(event)
            .then(function () {
            _this.log('sendEvent successfully!');
        })
            .catch(function (err) {
            _this.log('sendEvent# error', err);
        });
    };
    CoreServiceHelper.prototype.createCourseEvent = function (action, course) {
        var _this = this;
        var user = (0, UserCache_2.loadUser)();
        if (!user) {
            this.log('createCourseEvent# user not exist!');
        }
        var event = {
            user: user
                ? {
                    uid: user.uid,
                    email: user.email,
                    name: user.displayName,
                    role: user.role ? user.role : '',
                    unit: user.unit ? user.unit : '',
                }
                : '',
            env: this.env,
            action: action,
            course: course,
            localTime: (0, Utils_1.getTimeString)(),
        };
        this.createData('events_course', event)
            .then(function () {
            _this.log('createCourseEvent successfully!');
        })
            .catch(function (err) {
            _this.log('createCourseEvent# error', err);
        });
    };
    CoreServiceHelper.prototype.syncGoogleForm = function (id) {
        return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_sync_google_form, { id: id });
    };
    CoreServiceHelper.prototype.setSpeedListener = function (listener) {
        this.speedListener = listener;
    };
    CoreServiceHelper.prototype.fetchGoogleSpreadsheet = function (spreadsheetId, sheetCols) {
        var myHeaders = new Headers();
        myHeaders.append('access-token', '14137e4d-cad6-4cc1-b095-9a8c84fa1402');
        myHeaders.append('Content-Type', 'application/json');
        return this.postJson('https://api.codingbar.ai/service/googledocs/spreadsheet', {
            spreadsheetId: spreadsheetId,
            args: sheetCols,
        }, false, myHeaders);
    };
    CoreServiceHelper.prototype.verifyFreeTrialUserAccount = function (name, email) {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_db_verify_freeTrial_account, {
            name: name,
            email: email,
        }, false, myHeaders);
    };
    CoreServiceHelper.prototype.createUser = function (users) {
        var myHeaders = new Headers();
        myHeaders.append('access-token', '14137e4d-cad6-4cc1-b095-9a8c84fa1402');
        myHeaders.append('Content-Type', 'application/json');
        return this.postJson(Settings_1.Settings.SERVER_CONFIG.connections.api_create_user, users, false, myHeaders);
    };
    return CoreServiceHelper;
}());
exports.CoreServiceHelper = CoreServiceHelper;
//# sourceMappingURL=CoreServiceHelper.js.map